module.exports = __webpack_public_path__ + "static/vib_play4s-6ec5416a6ff8a1cb4b65e63ed175dd24.jpg";